import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import { Button, Divider, TextField, FormGroup, Grid, Radio, FormControl, RadioGroup, FormControlLabel, FormLabel } from '@material-ui/core'
//import VSelect from 'Components/Select/VSelect'
//import ManuelAddress from './ManuellAdressForm'
import { setAccountingRecipientType, setAccountingType, setTaskType, setRecipientType, resetAll } from 'store/actions/customerAccountingActions'

export class Configuration extends PureComponent {

    componentDidMount () {
        
    }
  
      handleAccountingRecipientType = value => {
        return setAccountingRecipientType(value)
      }
      handleAccountingType = value =>setAccountingType(value)


      handleRecipientType = value => {
        return setRecipientType(value)
      }
      handleTaskType = value => {
        return setTaskType(value)
      }
      handleReset = () =>{
          return resetAll()
      }
    render() {
        const { accountingRecipientType, accountingType, taskType, recipientType } = this.props.config
        const resetBtnDisabled = accountingRecipientType.length===0 || accountingType.length===0 || taskType.length===0 || recipientType.length===0
        return (
            <FormGroup>
                <TextField
                  label='App'
                  disabled={true}
                  value={this.props.activeApp ? this.props.activeApp.toUpperCase() : ''}
                /> 
                <RadioSelect
                    btnDisabled={this.props.configDisabled}
                    style={{marginTop: '1rem'}}
                    label='Abrechnungsempfänger'
                    onChange={this.handleAccountingRecipientType}
                    value={accountingRecipientType}
                    radios={[
                        {id: 1, value: 'provider', label: 'Helfer'},
                        {id: 2, value: 'requester', label: 'Bedarf'}
                    ]}
                />
                <Divider />
                <RadioSelect
                    btnDisabled={this.props.configDisabled}
                    style={{marginTop: '1rem'}}
                    label='Abrechnungsart'
                    onChange={this.handleAccountingType}
                    value={accountingType}
                    radios={[
                        {id: 1, value: 'debit', label: 'Lastschrift'},
                        {id: 2, value: 'credit', label: 'Gutschrift'}
                    ]}
                />
                <Divider />

                <RadioSelect
                    btnDisabled={this.props.configDisabled}
                    style={{marginTop: '1rem'}}
                    label='Leistung'
                    onChange={this.handleTaskType}
                    value={taskType}
                    radios={[
                        {id: 1, value: 'auto', label: 'Über Auswahl'},
                        {id: 2, value: 'manually', label: 'Manuell'}
                    ]}
                />
                <Divider />
                <RadioSelect
                    btnDisabled={this.props.configDisabled}
                    style={{marginTop: '1rem'}}
                    label='Abrechnungsempfänger'
                    onChange={this.handleRecipientType}
                    value={recipientType}
                    radios={[
                        {id: 1, value: 'select', label: 'Mitglied wählen'},
                        {id: 2, value: 'manuall', label: 'Manuell'}
                    ]}
                />
               
                <Button
                    disabled={resetBtnDisabled} 
                    onClick={this.handleReset}
                    size='small'
                    style={{marginTop: '1rem'}}
                    fullWidth
                    variant='contained'
                    color='secondary'
                >
                    Formular zurücksetzen
                </Button>
              </FormGroup>
        )
      }
}



export default compose(
firestoreConnect(() => [  
    //  { collection: 'accounting', doc: 'pflegekasse', subcollections: [{ collection: 'services' }], storeAs: 'servicesPflegekasse' },
    { collection: 'tasks', where: [['type', '==', 'nachbarschaftshilfe']], storeAs: 'accountingTasks' }

]), // or { collection: 'todos' }
connect((state) => {
    const { accountingTasks } = state.firestore.ordered
    return ({
        activeApp: state.user.settings.activeApp,
        config: state.customerAccounting.config,
        configDisabled: state.customerAccounting.services.length>0,
        tasks: accountingTasks && accountingTasks,
    })}),
)(Configuration)

function RadioSelect({label, radios, value, onChange, style, btnDisabled}) {

    const handleChange = (event) => {
        return onChange(event.target.value);
    }
    
    return (
        <FormControl component="fieldset" size='small' style={style}>
        <FormLabel component="legend">{label}</FormLabel>
        <RadioGroup
            aria-label="accounting-type-radio-btn"
            name="accountingTypeRadio" value={value}
            onChange={handleChange}
        >
            <Grid container>
            {radios.map(radioBtn=>
                <Grid key={radioBtn.id} item md={6}>
                    <FormControlLabel
                        labelPlacement="end"
                        disabled={btnDisabled}
                        size='small'
                        value={radioBtn.value}
                        control={<Radio color='primary' size='small'/>}
                        label={radioBtn.label}
                    />
                </Grid>
            )}
            </Grid>
        </RadioGroup>
        </FormControl>
    )
    }
